import { useEffect } from "react";

import {
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
  ReferenceArea,
} from "recharts";

import { Tooltip } from "./Tooltip";
import { COLORS } from "../../theme/colors";
import { TooltipContent } from "./TooltipContent";
import { nFormatter } from "../../services/utils";

export const BarChart = ({
  chartData,
  height,
  barSize,
  period,
  top,
  showLabelList,
  CustomLabelList,
  bars,
  hideYAxis,
  unit,
  dateDiff,
  xAxisPadding,
  referenceAreas,
  yDomain,
}) => {
  useEffect(() => {
    setTimeout(() => {
      const tags = document.getElementsByClassName("estimated-bar");
      if (tags.length) {
        for (const tag of tags) {
          tag.setAttribute("stroke", COLORS.darks[0][100]);
          tag.setAttribute("stroke-dasharray", 3);
        }
      }
    }, 800);
  }, []);

  return (
    <ResponsiveContainer width="100%" height={height || 200}>
      <ReBarChart
        data={chartData}
        margin={{
          top: top || 5,
          bottom: 5,
        }}
        barSize={barSize || 20}
      >
        <CartesianGrid vertical={false} strokeDasharray="5 2" />
        <XAxis tickLine={false} dataKey="x" padding={xAxisPadding} />
        {!hideYAxis && (
          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={nFormatter}
            domain={yDomain}
          />
        )}
        <Tooltip
          wrapperStyle={{ outline: "none" }}
          chartData={chartData}
          content={
            <TooltipContent
              chartData={chartData}
              period={period}
              dateDiff={dateDiff}
            />
          }
        />
        <Bar
          dataKey={bars && bars[0] ? bars[0].dataKey : "trading"}
          stackId="a"
          fill={bars && bars[0] ? bars[0].fill : COLORS.purple}
          unit={unit || (bars && bars[0] ? bars[0].unit : "")}
        />
        <Bar
          dataKey={bars && bars[1] ? bars[1].dataKey : "battery"}
          stackId="a"
          fill={bars && bars[1] ? bars[1].fill : "#4F31CF"}
          unit={unit || (bars && bars[1] ? bars[1].unit : "")}
        />
        <Bar
          dataKey={bars && bars[2] ? bars[2].dataKey : "ev"}
          stackId="a"
          fill={bars && bars[2] ? bars[2].fill : COLORS.cian}
          unit={unit || (bars && bars[2] ? bars[2].unit : "")}
        >
          {showLabelList && (
            <LabelList
              dataKey="total"
              content={CustomLabelList}
              position="top"
              offset={10}
            />
          )}
        </Bar>
        <Bar
          className="estimated-bar"
          dataKey="estimated"
          stackId="a"
          fill={COLORS.darks[0][10]}
          unit={unit || (bars && bars[0] ? bars[0].unit : "")}
        />
        {referenceAreas.map((item, i) => (
          <ReferenceArea
            key={i}
            dataKey={item.dataKey}
            x1={item.x1}
            x2={item.x2}
            strokeOpacity={0.3}
            label={item.label}
            fill={COLORS.darks[0][10]}
          />
        ))}
      </ReBarChart>
    </ResponsiveContainer>
  );
};

BarChart.defaultProps = {
  xAxisPadding: {},
  referenceAreas: [],
};
